<template>
	<div class="d-flex flex-row justify-center align-content-center px-0 pt-3">
		<botao-tooltip
			v-if="!visualizacao"
			icone="mdi-pencil"
			cor="grey"
			texto="Redigir"
			@click="redigir"
		></botao-tooltip>
		<botao-tooltip icone="mdi-text-box" cor="grey" texto="Visualizar" @click="visualizar"></botao-tooltip>
		<botao-tooltip
			v-if="!visualizacao"
			icone="mdi-delete"
			cor="grey"
			texto="Excluir"
			@click="excluir"
		></botao-tooltip>
	</div>
</template>

<script>
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'modelo-documento-revisao-botoes-acoes',
	components: { BotaoTooltip },
	props: {
		visualizacao: Boolean,
	},
	methods: {
		redigir() {
			this.$emit('redigir')
		},
		visualizar() {
			this.$emit('visualizar')
		},
		excluir() {
			this.$emit('excluir')
		},
	},
}
</script>
